import {
  Component,
  OnInit,
  Input,
  OnChanges,
  SimpleChanges,
} from '@angular/core';
import { ApiService } from '@shared/catalogue/services/api.service';
import { Urls } from '../../../../utils/catalogue/urls';
import { DATA_PER_PAGE,
         CANCEL,
         File_deleted } from '@root/app.constant';
import { ToastrService } from 'ngx-toastr';
import { CommonDataService } from '@root/shared/catalogue/services/common-data.service';

@Component({
  selector: 'app-catalog-investor-forms',
  templateUrl: './catalog-investor-forms.component.html',
  styleUrls: ['./catalog-investor-forms.component.scss'],
})
export class CatalogInvestorFormsComponent implements OnChanges {
  @Input() data: any[];

  investorFormsPDFsData = [];

  pageSize: number = DATA_PER_PAGE;

  constructor(
    public apiService: ApiService,
    private toastr: ToastrService,
    public commonDataService: CommonDataService
  ) {}

  ngOnChanges(changes: SimpleChanges) {
    if (changes['data'] && this.data) {
      this.filterPdf(this.data);
    }
  }

  getDocs = () => {
    this.apiService.getData(Urls.getSectionDocs).subscribe((response: any) => {
      this.filterPdf(response.data.list);
    });
  };

  public filterPdf(data: any[]) {
    const investorFormsPDFsData = data.filter((pdf) => {
      return pdf.type === 'Forms' || pdf.type === '7';
    });

    this.investorFormsPDFsData = [...investorFormsPDFsData];
  }

  public viewFile(path) {
    window.open(path, '_blank');
  }

  public deleteData(id) {
    this.commonDataService
      .confirm('Are you sure want to delete?', 'md')
      .then((confirmed) => {
        if (confirmed) {
          this.apiService
            .postData(Urls.deleteSectionDocuments, { id })
            .subscribe((response: any) => {
              this.toastr.success(File_deleted);
              this.getDocs();
            });
        }
      })
      .catch(() => {
        this.toastr.error(CANCEL);
      });
  }
}
